import React from 'react';
import { useTranslation } from 'react-i18next';

import { IngestionVolumeInfo } from '../../../../../../gamma-api';
import { formatFileCount } from '../../../../../utils/fileUtil';
import { EMPTY_VALUE } from '../../../../../utils/stringUtil';

import './index.less';
import { MAIN_CLASS_NAME } from './const';

export interface IResourceVolumeProps {
  value?: IngestionVolumeInfo;
}

const ResourceVolume: React.FC<IResourceVolumeProps> = ({ value }) => {
  const { t } = useTranslation();

  const getText = () => {
    if (!value) {
      return EMPTY_VALUE;
    }

    return t('Resource volume: Tokens', {
      tokenCount: formatFileCount(value.token_count || 0),
    });
  };

  return <span className={MAIN_CLASS_NAME}>{getText()}</span>;
};

export default ResourceVolume;
